import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import { useGet, usePost } from "src/http-clients/clients";
import { getActiveApp } from "src/redux/selectors/app";
import { ACTIVE_APP } from "src/utils/constants";

export const useGetProcurementRequestSingle = ({
  length,
  page,
  search,
  purchaseOrderId,
}: {
  length: number;
  page: number;
  search?: string;
  purchaseOrderId?: string;
}) => {
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(
    `/users/procurement-request/single/${purchaseOrderId}${queryData}`
  );
  return data;
};

export const useGetProcurementRequests = ({
  length,
  page,
  search,
  purchaseOrderId,
}: {
  length: number;
  page: number;
  search?: string;
  purchaseOrderId?: string;
}) => {
  const activeApp = useSelector(getActiveApp);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const endpoint = activeApp === ACTIVE_APP.STORE ? "created" : "received";
  const data = useGet(`/users/procurement-request/${endpoint}${queryData}`);
  return data;
};

export const useCreatePurchaseOrders = ({
  purchaseOrderId,
  vendorId,
}: {
  purchaseOrderId: string;
  vendorId: string;
}) => {
  return usePost(`/users/vendors/${vendorId}/${purchaseOrderId}/create-po`);
};

export const useUpdatePurchaseOrderStatus = ({
  purchaseOrderId,
  vendorId,
}: {
  purchaseOrderId: string;
  vendorId: string;
}) => {
  return usePost(
    `/users/vendors/${vendorId}/${purchaseOrderId}/update-po-status`
  );
};

export const useGetPurchaseOrders = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeApp = useSelector(getActiveApp);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const endpoint = activeApp === ACTIVE_APP.STORE ? "created" : "received";
  const data = useGet(`/users/purchase-orders/${endpoint}${queryData}`);
  return data;
};
